import { defBreadcrumb } from "../../data/DataBreadcrumb";
import BreadcrumbComponent from "../../components/UserInterface/BreadcrumbComponent";
import ContentContainer from '../ContentContainer/ContentContainer';
import HeadingComponent from "../../components/UserInterface/HeadingComponent";

type breadcrumbProps = {
  pageTitle: string;
  asPath: string;
};
export const breadcrumb = ({ pageTitle, asPath }: breadcrumbProps) => {
  return [
    ...defBreadcrumb,
    {
      "@type": "ListItem",
      position: "2",
      item: {
        "@id": process.env.baseURL + "/tentang-perusahaan",
        name: "Tentang Perusahaan"
      }
    },
    {
      "@type": "ListItem",
      position: "3",
      item: {
        "@id": process.env.baseURL + asPath,
        name: pageTitle
      }
    }
  ];
};

type contentProps = {
  items: any;
  heading: string;
  subSlug: string;
  data: any
  setOffset: (offset: number) => void;
};
export const Content = ({ items, heading, subSlug, data, setOffset }: contentProps) => {
  return (
    <>
      <BreadcrumbComponent items={items} />
      <HeadingComponent headingText={heading}></HeadingComponent>
      <ContentContainer subSlug={subSlug} data={data} setOffset={setOffset}></ContentContainer>
    </>
  );
};

